<template>
  <div class="warpper">
    <div class="img">
      <p class="img-text">
<!--        <img class="logo-img" src="../../assets/images/logo-512.png">-->
      </p>
      <h1 class="websiteTitle" v-text="websiteTitle"></h1>
    </div>
    <div class="container-img">
      <div class="left">
        <img class="login-image" src="../../assets/images/login-bg6.png">
      </div>
      <div class="right">
        <slot class="main-class"></slot>
      </div>
    </div>
    <p class="record_num" v-text="icp_number"></p>
  </div>
</template>

<script>
import util from "@/utils";

export default {
  // name: "main",
  data () {
    return {
      icp_number: process.env.VUE_APP_ICP_NUMBER,
      websiteTitle: process.env.VUE_APP_WEBSITE_TITLE,
    };
  },
}
</script>

<style lang="scss" scoped>
.warpper {
  background-image: url("../../assets/images/login-bg1.png");
  width: 100%;
  height: 100%;
  position: relative;
  background-position: center;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  overflow: hidden;
  .img {
    display: flex;
    flex-direction: column;
    // justify-content: space-between;
    // align-items: center;
    // position: absolute;
    // left: calc(50% - 100px);
    .websiteTitle {
      width: 100%;
      text-align: center;
      line-height: 50px;
      font-size: 28px;
      color: #fc701a !important;
      margin-top: 10%;
      font-weight: Bold;
    }
    .img-text {
      text-align: center;
      .logo-img {
        margin-top: 80px;
        height: 50px;
        width: 50px;
      }
    }
  }

  .container-img {
    background-color: #ffffff;
    width: 60%;
    // height: 60%;
    min-height: 55%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    position: relative;
    top: 5%;
    left: 20%;
    box-shadow: 0 0 30px #fc701a;
    .login-image {
      position: absolute;
      top: 20%;
      left: 2%;
      max-width: 55%;
      max-height: 70%;
      width: auto;
      height: auto;
    }
  }
  .right {
    background: #ffffff;
    width: 50%;
    // height: 100%;
    height: auto;
    margin: 0 !important;
  }
  .left {
    width: 45%;
  }
}
</style>